"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ikeaSharedLocalizedComponent = require("@ikea-aoa/ikea-shared-localized-component");

var _LanguagePickerEjs = _interopRequireDefault(require("./LanguagePicker.ejs.js"));

var _ikeaSharedComponent = require("@ikea-aoa/ikea-shared-component");

var _Console = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/Console"));

var _ComponentException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ComponentException"));

var _UrlUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/UrlUtility"));

var _IkeaLocale = _interopRequireDefault(require("./IkeaLocale"));

require("./LanguagePicker.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LOCALE_REGEXP = /\/([a-z]{2})\/([a-z]{2})\//;
/**
 * The expected use of this component is to enable user to choose a language in multi-language countries thus the list of available countries will be short.
 *
 * @example
 * <ikea-component name="LanguagePicker"></ikea-component>
 * @example
 * <LanguagePicker></LanguagePicker>
 */

var LanguagePicker = /*#__PURE__*/function (_AbstractLocalizedCom) {
  _inherits(LanguagePicker, _AbstractLocalizedCom);

  var _super = _createSuper(LanguagePicker);

  /**
   * Class constructor.
   *
   * @param {Element} element The associated element.
   */
  function LanguagePicker(element) {
    var _this;

    _classCallCheck(this, LanguagePicker);

    _this = _super.call(this, element);
    _this.opened = false;
    _this.visible = true;
    _this.languages = [];
    _this.selected = null;
    _this._clickOutsideListener = _this.handleClickOutside.bind(_assertThisInitialized(_this));
    _this._ikeaLocale = new _IkeaLocale.default();
    return _this;
  }
  /**
   * Called when the component is loaded the first time.
   *
   * @override
   */


  _createClass(LanguagePicker, [{
    key: "load",
    value: function load() {
      document.body.addEventListener('click', this._clickOutsideListener);
    }
    /**
     * Called when the component is removed.
     *
     * @override
     */

  }, {
    key: "destroy",
    value: function destroy() {
      document.body.removeEventListener('click', this._clickOutsideListener);
    }
    /**
     * Gets the template.
     *
     * @override
     * @returns {Function} Template parse function.
     */

  }, {
    key: "getTemplate",
    value: function getTemplate() {
      if (!this.selected && this.localized.localization.alternateLanguages && this.localized.localization.locale) {
        this.languages = this._parseLanguages(this.localized.localization.alternateLanguages);
        this.selected = this._getSelectedLanguage(this._getLanguage());

        this._verifyLocalization();
      }

      this.visible = !(this.languages.length === 0 || this.languages.length === 1 && this.languages[0].code === this._getLanguage());
      return _LanguagePickerEjs.default;
    }
    /**
     * Verifies related parts of this.localized.localization.
     */

  }, {
    key: "_verifyLocalization",
    value: function _verifyLocalization() {
      var alternativeLanguages = this.localized.localization.alternateLanguages;

      var language = this._getLanguage();

      var country = this._getCountry();

      if (alternativeLanguages.length > 0) {
        if (alternativeLanguages.length < 4) {
          _Console.default.warn('LanguagePicker: "alternativeLanguages" is too short.');

          return;
        } else if ((!this.props.redirect || country) && (!country || country.length !== 2)) {
          throw new _ComponentException.default("Locale's country part must be 2 characters long.", this);
        } else if ((!this.props.redirect || language) && (!language || language.length !== 2)) {
          throw new _ComponentException.default("Locale's language part must be 2 characters long.", this);
        }

        if (!this._ikeaLocale.isValidLocale(country, language)) {
          if (this._ikeaLocale.getLocalesForCountry(country).length === 0) {
            throw new _ComponentException.default("Locale's country part is not valid.", this);
          } else if (this._ikeaLocale.getLocalesForCountry(country).length === 1) {
            throw new _ComponentException.default("Locale's language part is not valid for its country part.", this);
          }

          throw new _ComponentException.default("The locale ".concat(language, "_").concat(country, " is not a valid combination."), this);
        }
      }
    }
    /**
     * Handle click outside of the component.
     *
     * @param {Event} event Event object.
     */

  }, {
    key: "handleClickOutside",
    value: function handleClickOutside(event) {
      var button = this.element.querySelector('.LanguagePicker .LanguagePicker__button');
      var ul = this.element.querySelector('.LanguagePicker ul');

      if (this.opened && !button.contains(event.target) && !ul.contains(event.target)) {
        this._toggleOpened();
      }
    }
    /**
     * Handles click on the language in the list of languages. Handles selection of language.
     *
     * @param {string} language Two character language code of the selected language.
     */

  }, {
    key: "handleListItemClick",
    value: function handleListItemClick(language) {
      if (!this.selected || this.selected.code !== language) {
        this.selected = this._getSelectedLanguage(language);
        this.trigger('select', {
          languageCode: this.selected.code,
          url: this.buildUrl()
        });

        if (this.props.redirect) {
          this.setUrl(this.buildUrl());
        }
      } else {
        this.trigger('select', {
          languageCode: this.selected.code,
          url: this.buildUrl()
        });
      }

      this._toggleOpened();
    }
    /**
     * Handles click on the language selector button.
     */

  }, {
    key: "handleButtonClick",
    value: function handleButtonClick() {
      this._toggleOpened();
    }
    /**
     * Build language objects from string.
     *
     * @param {string} languages In form "en:English;ar:Arabic".
     * @returns {object[]} Array with language objects, object example: {code: 'en', name: 'English'}.
     */

  }, {
    key: "_parseLanguages",
    value: function _parseLanguages(languages) {
      var languageObjects = languages.split(';').map(function (language) {
        var _language$split = language.split(':'),
            _language$split2 = _slicedToArray(_language$split, 2),
            code = _language$split2[0],
            name = _language$split2[1];

        return {
          code: code.toLowerCase(),
          name: name
        };
      }); // Exclude empty objects (may be caused by a ; at the end of parameter languages)

      languageObjects = languageObjects.filter(function (language) {
        return language.code && language.name;
      });
      return languageObjects;
    }
    /**
     * Toggles list with languages opened/closed.
     */

  }, {
    key: "_toggleOpened",
    value: function _toggleOpened() {
      this.opened = !this.opened;
      this.render();
    }
    /**
     * Gets the browser's current url location.
     *
     * @returns {string} The url.
     */

  }, {
    key: "getUrl",
    value: function getUrl() {
      return window.location.href;
    }
    /**
     * Sets the browser's location.
     *
     * @param {string} url The url to set location.href to.
     */

  }, {
    key: "setUrl",
    value: function setUrl(url) {
      window.location.href = url;
    }
    /**
     * Builds a url-string.
     *
     * @returns {string} The new URL.
     */

  }, {
    key: "buildUrl",
    value: function buildUrl() {
      var query = this._getSearchQuery();

      var urlParts = this.getUrl().split('#');
      var url = urlParts[0];
      var hash = urlParts[1] ? '#' + urlParts[1] : '';

      if (query.locale) {
        query.locale = this._getLanguage() + '_' + this._getCountry().toUpperCase();
        return url.split('?')[0] + _UrlUtility.default.buildQueryString(query) + hash;
      }

      return url.replace(LOCALE_REGEXP, "/".concat(this._getCountry(), "/").concat(this._getLanguage(), "/")) + hash;
    }
    /**
     * Returns the search query.
     *
     * @returns {object} Search query.
     */

  }, {
    key: "_getSearchQuery",
    value: function _getSearchQuery() {
      return _UrlUtility.default.getSearchQuery();
    }
    /**
     * Gets the country, from locale.
     *
     * @returns {string|null} Country.
     */

  }, {
    key: "_getCountry",
    value: function _getCountry() {
      return this.localized.localization.locale ? this.localized.localization.locale.split('_')[1].toLowerCase() : this._getCountryFromUrl();
    }
    /**
     * Gets the language, from locale.
     *
     * @returns {string|null} Language.
     */

  }, {
    key: "_getLanguage",
    value: function _getLanguage() {
      if (this.selected) {
        return this.selected.code;
      } else {
        return this.localized.localization.locale ? this.localized.localization.locale.split('_')[0] : this._getLanguageFromUrl();
      }
    }
    /**
     * Gets the country, from url.
     *
     * @returns {string|null} Country.
     */

  }, {
    key: "_getCountryFromUrl",
    value: function _getCountryFromUrl() {
      var match = this.getUrl().match(LOCALE_REGEXP);

      if (!match || match.length < 3) {
        return null;
      }

      return match[1].toLowerCase();
    }
    /**
     * Gets the language, from url.
     *
     * @returns {string|null} Language.
     */

  }, {
    key: "_getLanguageFromUrl",
    value: function _getLanguageFromUrl() {
      var match = this.getUrl().match(LOCALE_REGEXP);

      if (!match || match.length < 3) {
        return null;
      }

      return match[2].toLowerCase();
    }
    /**
     * Get the language in available languages that matches the language in url.
     *
     * @param {string} language Two letters language code.
     * @returns {object|null} Language object or null if not found.
     */

  }, {
    key: "_getSelectedLanguage",
    value: function _getSelectedLanguage(language) {
      return language ? this.languages.find(function (l) {
        return l.code === language;
      }) : null;
    }
    /**
     * Returns the component name.
     *
     * @override
     * @returns {string} Component name.
     */

  }], [{
    key: "componentName",
    get: function get() {
      return 'LanguagePicker';
    }
    /**
     * Returns the supported props.
     *
     * @override
     * @summary
     * redirect: If true, component will try to redirect to new url, will not if omitted or false.
     * position: Placement of component in LTR. Specify 'right' or 'left'. This governs how the drop-down list should align, and makes it possible for the component to do the opposite in RTL.
     * @returns {SupportedProp[]} Supported prop objects.
     */

  }, {
    key: "supportedProps",
    get: function get() {
      return [new _ikeaSharedComponent.SupportedProp('redirect', 'boolean', false, null, 'true'), new _ikeaSharedComponent.SupportedProp('position', 'string', false, ['right', 'left'], 'left')];
    }
    /**
     * Returns an array of supported instance events.
     *
     * @override
     * @summary
     * select: Triggered when a language is chosen.
     * @returns {[string]} Supported event names. Example: ['select'].
     */

  }, {
    key: "supportedEvents",
    get: function get() {
      return ['select'];
    }
  }]);

  return LanguagePicker;
}(_ikeaSharedLocalizedComponent.AbstractLocalizedComponent);

exports.default = LanguagePicker;